import { ProtectedRoute } from '@partiu/api/components/ProtectedRoute';
import { PropsWithChildren } from 'react';
import ReactDOM from 'react-dom/client';
import { pdfjs } from 'react-pdf';
import { Navigate, Route } from 'react-router-dom';
import { bookstoreSlugResolver } from '../../../packages/ui/resolvers/slugResolvers';
import { RootTemplate } from '../../../packages/ui/templates/RootTemplate';
import './index.css';
import { AudioBookPage } from './pages/AudioBook';
import { BookReader } from './pages/BookReader';
import { BookstorePage } from './pages/Bookstore';
import { ContactPage } from './pages/Contact';
import { HomePage } from './pages/Home';
import * as Sentry from '@sentry/react';
import { LegalPage } from './pages/Legal/Legal';
import { LoginPage } from './pages/Login/Login';
import { PDFReaderPage } from './pages/PDFReader';
import { ProfilePage } from './pages/Profile/Profile';
import { ReceivedBooksPage } from './pages/ReceivedBooks/ReceivedBooks';
import ExchangeBookPage from './pages/ExchangeBook/ExchangeBookPage';
import { browserTracingIntegration } from '@sentry/react';

// eslint-disable-next-line react-refresh/only-export-components
function BookstoreProtectedRoute({ children }: PropsWithChildren) {
  return (
    <ProtectedRoute loginPage="/login" showToast={false}>
      {children}
    </ProtectedRoute>
  );
}

const isProduction = process.env.REACT_APP_SENTRY_ENVIRONMENT === 'production';
if(isProduction) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? '0.0') || 0.0,
    release: process.env.REACT_APP_SENTRY_RELEASE || 'unknown-release',
    integrations: [browserTracingIntegration],
  });
}
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <RootTemplate themeResolver={bookstoreSlugResolver}>
    <Route path={'/login'} element={<LoginPage />} />
    <Route
      path={'/'}
      element={
        <BookstoreProtectedRoute>
          <HomePage />
        </BookstoreProtectedRoute>
      }
    />
    <Route
      path={'/perfil/*'}
      element={
        <BookstoreProtectedRoute>
          <ProfilePage />
        </BookstoreProtectedRoute>
      }
    />
    <Route
      path={'/acervo'}
      element={
        <BookstoreProtectedRoute>
          <BookstorePage />
        </BookstoreProtectedRoute>
      }
    />
    <Route
      path={'/banca'}
      element={
        <BookstoreProtectedRoute>
          <BookstorePage />
        </BookstoreProtectedRoute>
      }
    />
    <Route
      path={'/leitura/:id'}
      element={
        <BookstoreProtectedRoute>
          <BookReader />
        </BookstoreProtectedRoute>
      }
    />
    <Route
      path={'/audiobook/:id'}
      element={
        <BookstoreProtectedRoute>
          <AudioBookPage />
        </BookstoreProtectedRoute>
      }
    />
    <Route
      path={'/pdf/:id'}
      element={
        <BookstoreProtectedRoute>
          <PDFReaderPage />
        </BookstoreProtectedRoute>
      }
    />
    <Route
      path={'/biblioteca'}
      element={
        <BookstoreProtectedRoute>
          <ReceivedBooksPage />
        </BookstoreProtectedRoute>
      }
    />
    <Route
      path={'/revistas'}
      element={
        <BookstoreProtectedRoute>
          <ReceivedBooksPage />
        </BookstoreProtectedRoute>
      }
    />
    <Route
      path={'/recebidos/:bookUserId/troca'}
      element={
        <BookstoreProtectedRoute>
          <ExchangeBookPage />
        </BookstoreProtectedRoute>
      }
    />
    <Route
      path={'/recebidas'}
      element={
        <BookstoreProtectedRoute>
          <ReceivedBooksPage />
        </BookstoreProtectedRoute>
      }
    />
    <Route path={'/legal/*'} element={<LegalPage />} />
    <Route path={'/contato'} element={<ContactPage />} />
    <Route path={'*'} element={<Navigate to="/" />} />
  </RootTemplate>
);
